export default __webpack_public_path__ + "static/media/mobile.f28653a2.jpg";